import { combineReducers } from 'redux';

import Blockchain from './blockchain/reducers';
import Messages from './messages/reducers';

export default combineReducers({
    Blockchain,
    Messages
});